import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Table, Button, Modal, Input, Select, InputNumber, Pagination, Form, message, Tag, Dropdown, Typography, Space, Row, Col, Divider, Statistic, List, Popconfirm, Switch, Card, theme } from 'antd';
import { fetchCasescoresList, deleteCasescoresCase, fetchSelectCaseList, saveSelectCases, updateFinalScore, updateSort, getCaseRegion, caseTeamApi, caseRetireFlagApi, fetchCaseAwardCert, resetCaseAwardCert, fetchFinalScoreAdjustLogList, getCaseScoreList, lockJudgesScore } from '@services/Selection';
import { getAuthDictionary } from '@/services/Selection/case';
import './index.less';
import PageHeader from '@components/PageHeader/PageHeader';
import { filterFormGridLayout, filterFormItemLayout, filterFormItemStyle, computeButtonColLayout } from '@utils/property';
import { workspaceSelectionReviewCasePath, workspaceSelectionReviewRankingPath, workspaceSelectionReviewTopicsPath } from '@/layouts/selectionWorkspacePaths';
const assignmentSelect = [
    { label: '全部', value: '0' },
    { label: '已分配', value: '1' },
    { label: '未分配', value: '2' },
];
const filesSelect = [
    { label: '全部', value: '0' },
    { label: '已上传', value: '1' },
    { label: '未上传', value: '2' },
];
const teamsSelect = [
    { label: '全部', value: '0' },
    { label: '已添加', value: '1' },
    { label: '未添加', value: '2' },
];

const CASES_FILTER_FIELD_COUNT = 5;
const casesFilterButtonColLayout = computeButtonColLayout(CASES_FILTER_FIELD_COUNT);

/** 评议实践列表筛选默认值（稳定引用，避免 Form 重复初始化） */
const CASES_FILTER_INITIAL_VALUES = {
    assignedState: '0',
    filesState: '0',
    teamsState: '0',
};

/** 整理列表筛选参数：去掉空字符串，Select 值统一为数字 */
const buildCasesFilterParams = formData => {
    const params = { ...formData };
    if (!params.caseName) delete params.caseName;
    if (!params.caseId) delete params.caseId;
    ['assignedState', 'filesState', 'teamsState'].forEach(key => {
        if (params[key] === undefined || params[key] === null || params[key] === '') {
            delete params[key];
            return;
        }
        params[key] = Number(params[key]);
    });
    return params;
};

/** 阶段材料 / 阶段参与人筛选需前端过滤（接口侧暂未生效） */
const needsClientCaseFilter = filterParams => filterParams.filesState === 1 || filterParams.filesState === 2 || filterParams.teamsState === 1 || filterParams.teamsState === 2;

/** 按列表展示规则做前端筛选 */
const applyClientCaseFilters = (list, filterParams) => {
    let result = list;
    if (filterParams.filesState === 1) {
        result = result.filter(item => item.caseAttachmentStatus !== undefined && item.caseAttachmentStatus !== null);
    } else if (filterParams.filesState === 2) {
        result = result.filter(item => item.caseAttachmentStatus === undefined || item.caseAttachmentStatus === null);
    }
    if (filterParams.teamsState === 1) {
        result = result.filter(item => Number(item.teamMembers) > 0);
    } else if (filterParams.teamsState === 2) {
        result = result.filter(item => !Number(item.teamMembers));
    }
    return result;
};

/** 减分理由多条拼接分隔符（仅提交接口时使用） */
const ADJUST_REASON_API_SEPARATOR = '；';

/** 换行拆条后，去掉各行末尾句读符号再拼接，避免「。；」重复标点 */
const TRAILING_PUNCTUATION_RE = /[。，、；;,.!?！？…]+$/u;

/**
 * 将输入框减分理由转为接口传参：按换行拆条，去掉各行末尾标点后以分号拼接
 * @param {string} reason
 * @returns {string}
 */
const formatAdjustReasonForApi = reason => {
    const text = (reason || '').trim();
    if (!text) return '';
    const lines = text
        .split(/\n+/)
        .map(s => s.trim())
        .filter(Boolean);
    if (lines.length <= 1) return lines[0] || '';
    return lines
        .map(s => s.replace(TRAILING_PUNCTUATION_RE, '').trim())
        .filter(Boolean)
        .join(ADJUST_REASON_API_SEPARATOR);
};

const casesColumns = [
    {
        title: '实践名称',
        dataIndex: 'key',
        align: 'topicName',
        render: (_, row) => {
            let fieldValue;
            if (row.fieldValue) {
                fieldValue = JSON.parse(row.fieldValue);
            }
            return (
                (
                    <div>
                        <div>{fieldValue.title}</div>
                        <div>#{row.id}</div>
                    </div>
                ) ?? '-'
            );
        },
    },
    {
        title: '申报机构',
        dataIndex: 'hospitalName',
        align: 'center',
    },
    {
        title: '提报用户',
        dataIndex: 'nickName',
        align: 'center',
    },
    {
        title: '提报时间',
        dataIndex: 'createdAt',
        align: 'center',
    },
];

const ScoreStageTopicList = () => {
    const params = useParams();
    const navigate = useNavigate();
    const local = useLocation();
    const { token } = theme.useToken();

    const [form] = Form.useForm();
    const [paginat, setPaginat] = useState({ page: 1, size: 10 });
    const [tableLoading, setTableLoading] = useState(false);
    const [dataSource, setDataSource] = useState({ list: [], totalCount: 0 });
    const [currentSort, setCurrentSort] = useState(null);

    const [topicForm] = Form.useForm();
    const [casesModal, setCasesModal] = useState(false);
    const [selectTableLoading, setSelectTableLoading] = useState(false);
    const [casesPaginat, setCasesPaginat] = useState({ page: 1, size: 10 });
    const [casesDataSource, setCasesDataSource] = useState({ list: [], totalCount: 0 });
    const [casesRegions, setCasesRegion] = useState([{ value: '全部区域', label: '全部区域' }]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    const [memberModalOpen, setMemberModalOpen] = useState(false);
    const [currentCase, setCurrentCase] = useState(undefined);
    const [memberDatas, setMemberDatas] = useState([]);
    const [memberLoading, setMemberLoading] = useState(false);

    const [departments, setDepartments] = useState(undefined); // ksh
    const [posts, setPosts] = useState(undefined); // zhw
    const [titles, setTitles] = useState(undefined); // zhch

    const [fractionModal, setFractionModal] = useState(false);
    const [finallyScore, setFinallyScore] = useState({ id: '', finalScore: 0, averageScore: 0 });
    const [adjustForm] = Form.useForm();
    const adjustPoints = Form.useWatch('points', adjustForm);
    const [adjustRecords, setAdjustRecords] = useState([]);
    const [adjustRecordsLoading, setAdjustRecordsLoading] = useState(false);
    const [adjustFormDirty, setAdjustFormDirty] = useState(false);
    const recordListRef = useRef(null);
    const [showRecordScrollFade, setShowRecordScrollFade] = useState(false);
    const [scoreLocked, setScoreLocked] = useState(false);
    const [lockLoading, setLockLoading] = useState(false);
    const casesDataSourceRef = useRef(casesDataSource);
    const lastFilterRef = useRef(CASES_FILTER_INITIAL_VALUES);

    useEffect(() => {
        casesDataSourceRef.current = casesDataSource;
    }, [casesDataSource]);

    const initList = () => {
        getAuthDictionary({ identity: 'A01', type: 'KSH' }).then(res => {
            if (res) {
                setDepartments(res.data);
            }
        });
        getAuthDictionary({ identity: 'A01', type: 'ZHW' }).then(res => {
            if (res) {
                setPosts(res.data);
            }
        });
        getAuthDictionary({ identity: 'A01', type: 'ZHCH' }).then(res => {
            if (res) {
                setTitles(res.data);
            }
        });
    };

    // 获取字典名称
    const getDicName = (datas, dicCode) => {
        console.log(datas);
        let name = '';
        datas.forEach(item => {
            if (item.dicCode === dicCode) {
                name = item.dicName;
            } else {
                item.children
                    && item.children.forEach(i => {
                        if (i.dicCode === dicCode) {
                            name = i.dicName;
                        }
                    });
            }
        });

        return name;
    };
    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys);
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        preserveSelectedRowKeys: true,
    };

    useEffect(() => {
        getCaseRegion({ projectId: params.pid }).then(res => {
            if (res.status_code === 200) {
                const regions = JSON.parse(res?.data?.regions || '[]');
                setCasesRegion(draft => [...draft, ...regions.map(item => ({ value: item.name, label: item.name }))]);
            }
        });
    }, [params.pid]);

    const fetchList = useCallback(
        async ({ page, size }) => {
            setTableLoading(true);
            const formData = buildCasesFilterParams(lastFilterRef.current);
            const baseParams = { projectId: params.pid, stageId: params.sid, topicId: params.tid, ...formData };

            try {
                if (needsClientCaseFilter(formData)) {
                    const countRes = await fetchCasescoresList({ ...baseParams, page: 1, size: 1 });
                    if (countRes?.status_code !== 200) {
                        return;
                    }
                    const totalCount = countRes.data?.totalCount || 0;
                    if (!totalCount) {
                        setDataSource({ list: [], totalCount: 0 });
                        return;
                    }
                    const allRes = await fetchCasescoresList({ ...baseParams, page: 1, size: totalCount });
                    if (allRes?.status_code !== 200) {
                        return;
                    }
                    const filtered = applyClientCaseFilters(allRes.data?.list || [], formData);
                    const pageList = filtered.slice((page - 1) * size, page * size).map((item, index) => ({ ...item, index }));
                    setDataSource({ list: pageList, totalCount: filtered.length });
                    return;
                }

                const res = await fetchCasescoresList({ ...baseParams, page, size });
                if (res?.status_code === 200) {
                    setDataSource({ list: res.data?.list.map((item, index) => ({ ...item, index })), totalCount: res.data.totalCount });
                }
            } finally {
                setTableLoading(false);
            }
        },
        [params],
    );

    const handleSearch = useCallback(() => {
        const values = form.getFieldsValue();
        lastFilterRef.current = values;
        setPaginat(draft => ({ page: 1, size: draft.size }));
    }, [form]);

    const handleResetFilters = useCallback(() => {
        form.resetFields();
        lastFilterRef.current = { ...CASES_FILTER_INITIAL_VALUES };
        setPaginat(draft => ({ page: 1, size: draft.size }));
    }, [form]);

    /** 操作成功后按当前分页重新拉取列表，避免 columns 闭包中的 paginat 过期 */
    const refreshList = useCallback(() => {
        setPaginat(draft => ({ ...draft }));
    }, []);

    useEffect(() => {
        initList();
        fetchList(paginat);
    }, [fetchList, paginat]);

    useEffect(() => {
        document.title = '评议实践管理-医评议';
    }, []);

    useEffect(() => {
        getCaseScoreList({ projectId: params.pid, stageId: params.sid, topicId: params.tid, platformType: 'pc' }).then(res => {
            if (res?.status_code === 200) {
                setScoreLocked(!!res?.data?.lockedJudgesScore);
            }
        });
    }, [params.pid, params.sid, params.tid]);

    /** 确认锁定/解锁专家评分 */
    const handleLockConfirm = useCallback(() => {
        const nextLocked = !scoreLocked;
        setLockLoading(true);
        lockJudgesScore({
            stageId: Number(params.sid),
            topicId: Number(params.tid),
            state: nextLocked,
        })
            .then(res => {
                if (res?.status_code === 200) {
                    setScoreLocked(nextLocked);
                    message.success(nextLocked ? '专家评分已锁定' : '专家评分已解锁');
                }
            })
            .finally(() => {
                setLockLoading(false);
            });
    }, [params.sid, params.tid, scoreLocked]);

    const checkList = useCallback(() => {
        navigate(workspaceSelectionReviewRankingPath(params.pid, params.sid, params.tid));
    }, [navigate, params.pid, params.sid, params.tid]);

    const selectList = useCallback(() => {
        if (!casesDataSourceRef.current.totalCount) {
            return message.warning('无评议实践!');
        }
        setCasesModal(true);
    }, []);

    const fetchSelectCasesList = useCallback(
        ({ page, size }) => {
            setSelectTableLoading(true);
            const formData = topicForm.getFieldsValue();
            if (formData.region === '全部区域') {
                delete formData.region;
            }

            fetchSelectCaseList({ stageId: params.sid, topicId: params.tid, ...formData, page, size })
                .then(res => {
                    if (res?.status_code === 200) {
                        setCasesDataSource({ list: res.data?.records.map((i, index) => ({ ...i, index })), totalCount: res.data.total });
                    }
                })
                .finally(() => {
                    setSelectTableLoading(false);
                });
        },
        [params.sid, params.tid, topicForm],
    );

    useEffect(() => {
        fetchSelectCasesList(casesPaginat);
    }, [casesPaginat, fetchSelectCasesList]);

    const onClickMenu = async (e, row) => {
        console.log(e, row);
        switch (e.key) {
            case 'reset-cert': {
                const res = await resetCaseAwardCert({
                    projectId: params.pid,
                    topicId: params.tid,
                    stageId: params.sid,
                    caseId: row.caseId,
                });
                if (res.status_code === 200) {
                    message.success('证书重置成功');
                    refreshList();
                }
                break;
            }
            default:
                break;
        }
    };

    const onViewCert = async row => {
        // console.log(row);
        const res = await fetchCaseAwardCert({
            projectId: params.pid,
            stageId: params.sid,
            caseId: row.caseId,
        });
        if (res.status_code === 200) {
            console.log(res);
            const url = res.data?.imageUrl || '';
            if (/^https?:\/\//i.test(url)) {
                window.open(url, '_target');
            }
        }
    };

    /** 清空调分弹窗展示数据 */
    const resetAdjustModalData = useCallback(() => {
        adjustForm.resetFields();
        setAdjustFormDirty(false);
        setAdjustRecords([]);
        setAdjustRecordsLoading(false);
    }, [adjustForm]);

    /** 加载调分记录 */
    const loadAdjustRecords = useCallback(
        caseId => {
            if (!caseId) return;

            setAdjustRecordsLoading(true);
            fetchFinalScoreAdjustLogList({
                caseId,
                projectId: Number(params.pid),
                stageId: Number(params.sid),
                topicId: Number(params.tid),
            })
                .then(res => {
                    if (res?.status_code === 200) {
                        setAdjustRecords(res.data || []);
                    }
                })
                .finally(() => setAdjustRecordsLoading(false));
        },
        [params.pid, params.sid, params.tid],
    );

    /** 打开实践调分弹窗 */
    const openAdjustModal = useCallback(
        caseData => {
            resetAdjustModalData();
            setCurrentCase(caseData);
            setFinallyScore({ finalScore: caseData.finalScore, id: caseData.caseId, averageScore: caseData.score });
            setFractionModal(true);
            loadAdjustRecords(caseData.caseId);
        },
        [resetAdjustModalData, loadAdjustRecords],
    );

    const columns = useMemo(() => {
        const handleSortBlur = (value, current) => {
            setCurrentSort(null);
            if (!value || current === value) {
                return;
            }
            updateSort({ projectId: params.pid, stageId: params.sid, topicId: params.tid, caseId: currentSort, sort: +value }).then(res => {
                if (res.status_code === 200) {
                    setPaginat(d => ({ page: 1, size: d.size }));
                }
            });
        };

        const handleShowInput = caseId => {
            setCurrentSort(caseId);
        };

        return [
            {
                title: '排序',
                dataIndex: 'sort',
                align: 'center',
                width: 120,
                render: (row, data) => {
                    return currentSort === data.caseId ? <InputNumber onBlur={e => handleSortBlur(e.target.value)} autoFocus precision={0} /> : <span onClick={() => handleShowInput(data.caseId, row)}>{row ?? '-'}</span>;
                },
            },
            {
                title: '申报名称',
                dataIndex: 'caseName',
                render: (row, data) => {
                    return (
                        <>
                            <div
                                className="lasttime-span"
                                onClick={() => {
                                    navigate(`/selection/cases/${data.caseId}`);
                                }}
                            >
                                {!!data.retireFlag && (
                                    <Tag color="#f50" style={{ padding: '0 4px' }}>
                                        弃赛
                                    </Tag>
                                )}
                                {row}
                            </div>
                            <div>#{data.caseId}</div>
                        </>
                    );
                },
            },
            {
                title: '申报机构',
                dataIndex: 'hospitalName',
                align: 'center',
                render: row => row ?? '-',
            },
            {
                title: '阶段材料',
                dataIndex: 'caseAttachmentStatus',
                align: 'center',
                width: 80,
                render: row => {
                    return (
                        <>
                            {row === undefined && <span className="redSpan">未上传</span>}
                            {row === 0 && (
                                <>
                                    <span className="lasttime-span">已上传</span>
                                    <br />
                                    <small>审核中</small>
                                </>
                            )}
                            {row === 1 && (
                                <>
                                    <span className="lasttime-span">下载</span>
                                    <br />
                                    <small>审核通过</small>
                                </>
                            )}
                            {row === 2 && (
                                <>
                                    <span className="lasttime-span">已上传</span>
                                    <br />
                                    <small>驳回</small>
                                </>
                            )}
                        </>
                    );
                },
            },
            {
                title: '阶段参与人',
                dataIndex: 'teamMembers',
                align: 'center',
                width: 80,
                render: (row, data) => {
                    return (
                        <span className="lasttime-span" onClick={() => openMemberManager(data)}>
                            {row === 0 ? '未参加' : `${row}人`}
                        </span>
                    );
                },
            },
            {
                title: '评议专家/已评',
                key: 'id',
                align: 'center',
                width: 80,
                render: row => {
                    return (
                        <span
                            className="lasttime-span"
                            onClick={() =>
                                navigate(workspaceSelectionReviewCasePath(params.pid, params.sid, params.tid, row.caseId), {
                                    state: { decimalPlaceNum: local?.state?.decimalPlaceNum, projectName: local?.state?.projectName, stageName: local?.state?.stageName, topicName: local?.state?.topicName, caseName: row.caseName, caseId: row.caseId, hospitalName: row.hospitalName },
                                })
                            }
                        >
                            {row.judgesNumber ?? '-'}/{row.scoredNumber ?? '-'}
                        </span>
                    );
                },
            },
            {
                title: '系统得分',
                dataIndex: 'score',
                align: 'center',
                width: 80,
                render: (row, data) => {
                    return !data.scoredNumber && data.scoredNumber !== 0 ? '-' : (row ?? '-');
                },
            },
            {
                title: '展示得分',
                dataIndex: 'finalScore',
                align: 'center',
                width: 80,
                render: (row, data) => {
                    return (
                        <span className="lasttime-span" onClick={() => openAdjustModal(data)}>
                            {!data.scoredNumber && data.scoredNumber !== 0 && data.score === data.finalScore ? '-' : (row ?? '-')}
                        </span>
                    );
                },
            },
            {
                title: '结果证书',
                dataIndex: 'finishCert',
                width: 110,
                render: (_, row) => {
                    const menuProps = {
                        items: [{ label: '重置证书', key: 'reset-cert', danger: true }],
                        onClick: e => onClickMenu(e, row),
                    };
                    return !!row?.caseAwardCertificateStatus ? (
                        <Space.Compact>
                            <Button size="small" onClick={() => onViewCert(row)}>
                                查看证书
                            </Button>
                            <Dropdown menu={menuProps} trigger={['click']}>
                                <Button size="small" icon={<i className="bi bi-chevron-down"></i>} />
                            </Dropdown>
                        </Space.Compact>
                    ) : (
                        <Typography.Text type="secondary">未生成</Typography.Text>
                    );
                },
            },
            {
                title: '操作',
                width: 200,
                dataIndex: 'id',
                align: 'center',
                render: (row, record) => {
                    return (
                        <React.Fragment>
                            <Button
                                type="link"
                                onClick={() => {
                                    caseRetireFlagApi({ id: row }).then(res => {
                                        if (res?.status_code === 200) {
                                            message.success('操作成功！');
                                            refreshList();
                                        }
                                    });
                                }}
                            >
                                {record.retireFlag ? '恢复为参赛' : '标记为弃权'}
                            </Button>
                            <Button
                                type="link"
                                onClick={() => {
                                    deleteCasescoresCase({ id: row }).then(res => {
                                        if (res?.status_code === 200) {
                                            message.success('删除成功！');
                                            refreshList();
                                        }
                                    });
                                }}
                            >
                                移除实践
                            </Button>
                        </React.Fragment>
                    );
                },
            },
        ];
    }, [currentSort, local?.state?.decimalPlaceNum, navigate, openAdjustModal, params.pid, params.sid, params.tid, refreshList]);

    const teamStageColumns = [
        {
            title: '手机号',
            dataIndex: 'mobile',
            key: 'mobile',
        },
        {
            title: '姓名',
            dataIndex: 'username',
            key: 'username',
        },
        {
            title: '科室部门',
            key: 'memOffice',
            dataIndex: 'memOffice',
            render: (_, record) => <>{!!record.memOffice && getDicName(departments, record.memOffice)}</>,
        },
        {
            title: '职务',
            key: 'memPost',
            dataIndex: 'memPost',
            render: (_, record) => <>{!!record.memPost && getDicName(posts, record.memPost)}</>,
        },
        {
            title: '职称',
            key: 'memJobtitle',
            dataIndex: 'memJobtitle',
            render: (_, record) => <>{!!record.memJobtitle && getDicName(titles, record.memJobtitle)}</>,
        },
        {
            title: '任务',
            dataIndex: 'memTask',
            key: 'memTask',
        },
    ];

    const casesHeader = useMemo(() => {
        const submit = () => {
            setCasesPaginat({ page: 1, size: 10 });
        };

        return (
            <div className="cases-table-casesHeader">
                <Form form={topicForm} name="cases-select-form" initialValues={{ region: '全部区域' }} layout="inline">
                    <div className="form-flex-wrapper">
                        <Form.Item name="region" label="区域">
                            <Select style={{ width: 140 }} options={casesRegions} />
                        </Form.Item>
                        <Form.Item name="caseId" label="申报ID">
                            <Input placeholder="申报ID" style={{ width: 140 }} />
                        </Form.Item>
                        <Form.Item name="caseName" label="实践名称">
                            <Input placeholder="名称" style={{ width: 140 }} />
                        </Form.Item>
                        <Form.Item name="hospitalName" label="提报单位">
                            <Input style={{ width: 140 }} />
                        </Form.Item>

                        <Button type="primary" onClick={submit}>
                            检索
                        </Button>
                    </div>

                    <div className="cases-table-casesHeader-count">
                        <span>共{casesDataSource.totalCount}实践</span>
                        <span>已选{selectedRowKeys.length}实践</span>
                        <span>未选{casesDataSource.totalCount - selectedRowKeys.length}实践</span>
                    </div>
                </Form>
            </div>
        );
    }, [casesDataSource.totalCount, casesRegions, selectedRowKeys.length, topicForm]);
    const openMemberManager = data => {
        setMemberDatas([]);

        setCurrentCase(data);
        setMemberModalOpen(true);
        getlistByStageId(data.caseId, data.stageId);
    };
    const getlistByStageId = (caseId, stageId) => {
        setMemberLoading(true);
        caseTeamApi({
            caseId,
            stageId,
        })
            .then(res => {
                setMemberLoading(false);
                if (res?.status_code === 200) {
                    setMemberDatas(res.data);
                }
            })
            .catch(err => {
                setMemberLoading(false);
            });
    };

    const onDataSourcePagination = (page, size) => {
        setPaginat({ page, size });
    };

    const selectCasesPaginationChange = (page, size) => {
        setCasesPaginat({ page, size });
    };

    const casesFooter = useMemo(() => {
        const submitSelect = () => {
            if (selectedRowKeys.length) {
                saveSelectCases({ projectId: params.pid, stageId: params.sid, topicId: params.tid, caseIds: selectedRowKeys }).then(res => {
                    if (res?.status_code === 200) {
                        message.success('添加成功！');
                        setCasesModal(false);
                        setPaginat(draft => ({ page: 1, size: draft.size }));
                    }
                });
            } else {
                setCasesModal(false);
            }
        };

        return (
            <div className="cases-table-footer">
                <Pagination
                    className="my-pagintation-class"
                    showTotal={() => `共${casesDataSource.totalCount}条 ${Math.ceil(casesDataSource.totalCount / casesPaginat.size)} 页`}
                    total={casesDataSource.totalCount}
                    showSizeChanger
                    showQuickJumper
                    onChange={selectCasesPaginationChange}
                    current={casesPaginat.page}
                    size={casesPaginat.size}
                />
                <Button type="primary" onClick={submitSelect}>
                    确定
                </Button>
            </div>
        );
    }, [casesDataSource.totalCount, casesPaginat.page, casesPaginat.size, params.pid, params.sid, params.tid, selectedRowKeys]);

    /** 格式化分数：整数不显示小数，有小数最多保留4位（去掉末尾多余的0） */
    const formatScore = v => {
        if (v === null || v === undefined || v === '-') return v;
        const num = typeof v === 'string' ? parseFloat(v) : v;
        if (isNaN(num)) return v;
        return parseFloat(num.toFixed(4));
    };

    /** 校验扣除总分是否有效，有效时返回扣除后的最终显示得分 */
    const getDeductPointsPreviewScore = (points, systemScore) => {
        if (points === null || points === undefined || points === '') {
            return null;
        }
        const decimalPart = String(points).split('.')[1];
        if (decimalPart && decimalPart.length > 4) {
            return null;
        }
        const pointsNum = Number(points);
        const systemScoreNum = Number(systemScore);
        if (Number.isNaN(pointsNum) || pointsNum < 0 || Number.isNaN(systemScoreNum)) {
            return null;
        }
        if (pointsNum > systemScoreNum) {
            return null;
        }
        return formatScore(systemScoreNum - pointsNum);
    };

    /** 扣除总分表单项 label：有效输入时展示扣除后的最终显示得分 */
    const deductPointsLabel = useMemo(() => {
        const previewScore = getDeductPointsPreviewScore(adjustPoints, finallyScore.averageScore);
        if (previewScore === null || previewScore === undefined) {
            return '扣除总分';
        }
        return `扣除总分（扣除后最终显示得分：${previewScore}分）`;
    }, [adjustPoints, finallyScore.averageScore]);

    /** 渲染单条调分记录：按 scoreSource 区分人工/系统，minusScore 为 0 视为重置 */
    const renderAdjustRecordItem = r => {
        const isSystemSource = r.scoreSource === 'BOSS';
        const isReset = Number(r.minusScore ?? 0) === 0;
        const operator = r.createdBy || (isSystemSource ? '系统' : '-');
        const header = `${operator} · ${r.createdAt}`;
        const recordReason = r.reason || r.reasons;

        if (isReset) {
            const resetLabel = isSystemSource ? '系统重置分数' : '人工重置分数';
            const resetClass = isSystemSource ? 'score-adjust-reset-system' : 'score-adjust-reset-manual';

            return (
                <List.Item className="score-adjust-record-item">
                    <div className="score-adjust-record-content">
                        <Typography.Text type="secondary" className="score-adjust-record-meta">
                            {header}
                        </Typography.Text>
                        <Typography.Text className="score-adjust-record-formula">
                            <span className={resetClass}>{resetLabel}</span>
                            ：最终显示得分（<span className="score-adjust-highlight">{formatScore(r.originalScore)}分</span>）= 系统最终得分（<span className="score-adjust-base-score">{formatScore(r.originalScore)}分</span>）
                        </Typography.Text>
                    </div>
                </List.Item>
            );
        }

        return (
            <List.Item className="score-adjust-record-item">
                <div className="score-adjust-record-content">
                    <Typography.Text type="secondary" className="score-adjust-record-meta">
                        {header}
                    </Typography.Text>
                    <Typography.Text className="score-adjust-record-formula">
                        最终显示得分（<span className="score-adjust-highlight">{formatScore((r.originalScore ?? 0) - (r.minusScore ?? 0))}分</span>）= 系统最终得分（<span className="score-adjust-base-score">{formatScore(r.originalScore)}分</span>）- 扣除总分（
                        <span className="score-adjust-deduct">{formatScore(r.minusScore ?? 0)}分</span>）
                    </Typography.Text>
                    {recordReason && (
                        <Typography.Text className="score-adjust-record-reason">
                            调分理由：<span className="score-adjust-reason-text">{recordReason}</span>
                        </Typography.Text>
                    )}
                </div>
            </List.Item>
        );
    };

    /** 备选理由（点击快速填入减分理由输入框） */
    const REASON_PRESETS = useMemo(() => ['实践中出现单位名称、Logo或院领导信息', '实践讲解超时'], []);

    /** 记录列表底部渐隐效果 */
    const updateRecordScrollFade = useCallback(() => {
        const el = recordListRef.current;
        if (!el) return;
        const hasOverflow = el.scrollHeight > el.clientHeight + 1;
        const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1;
        setShowRecordScrollFade(hasOverflow && !atBottom);
    }, []);

    useEffect(() => {
        if (!fractionModal) return;
        updateRecordScrollFade();
        const el = recordListRef.current;
        if (!el) return;
        const resizeObserver = new ResizeObserver(updateRecordScrollFade);
        resizeObserver.observe(el);
        return () => resizeObserver.disconnect();
    }, [fractionModal, adjustRecords, updateRecordScrollFade]);

    /** 点击备选理由，换行追加到减分理由输入框（不覆盖已有内容）；提交接口时按换行转分号拼接 */
    const handleReasonPresetClick = preset => {
        const currentReason = adjustForm.getFieldValue('reason') || '';
        if (currentReason.includes(preset)) return;
        const separator = currentReason && !currentReason.endsWith('\n') ? '\n' : '';
        const newReason = `${currentReason}${separator}${preset}`.slice(0, 200);
        adjustForm.setFieldValue('reason', newReason);
        setAdjustFormDirty(true);
    };

    /** 提交减分（确认减分），二次确认后调用接口 */
    const handleAdjustSubmit = values => {
        const reason = formatAdjustReasonForApi(values.reason);
        const newFinalScore = formatScore(finallyScore.averageScore - (values.points || 0));
        Modal.confirm({
            title: '提示',
            content: (
                <span>
                    最新展示得分由<span style={{ color: 'var(--ant-color-error, #ff4d4f)', fontWeight: 600 }}>{formatScore(finallyScore.finalScore)}</span>分调整为<span style={{ color: 'var(--ant-color-error, #ff4d4f)', fontWeight: 600 }}>{newFinalScore}</span>分，确认调整为该分数?
                </span>
            ),
            okText: '确定',
            cancelText: '取消',
            onOk() {
                return updateFinalScore({
                    projectId: Number(params.pid),
                    stageId: Number(params.sid),
                    topicId: Number(params.tid),
                    caseId: finallyScore.id,
                    minusScore: values.points || 0,
                    reasons: reason,
                }).then(res => {
                    if (res?.status_code === 200) {
                        message.success('调整成功');
                        adjustForm.setFieldsValue({ points: undefined, reason: undefined });
                        setAdjustFormDirty(false);
                        loadAdjustRecords(finallyScore.id);
                        setPaginat(draft => ({ ...draft }));
                        setFinallyScore(prev => ({
                            ...prev,
                            finalScore: formatScore(prev.averageScore - (values.points || 0)),
                        }));
                    }
                });
            },
        });
    };

    /** 重置分数：重置后展示得分回到系统得分 */
    const handleResetScore = () => {
        Modal.confirm({
            title: '提示',
            content: (
                <span>
                    最新展示得分由<span style={{ color: 'var(--ant-color-error, #ff4d4f)', fontWeight: 600 }}>{formatScore(finallyScore.finalScore)}</span>分重置为<span style={{ color: 'var(--ant-color-error, #ff4d4f)', fontWeight: 600 }}>{formatScore(finallyScore.averageScore)}</span>分，确认重置为该分数?
                </span>
            ),
            okText: '确定',
            cancelText: '取消',
            onOk() {
                return updateFinalScore({
                    projectId: Number(params.pid),
                    stageId: Number(params.sid),
                    topicId: Number(params.tid),
                    caseId: finallyScore.id,
                    minusScore: 0,
                    reasons: '重置展示得分',
                }).then(res => {
                    if (res?.status_code === 200) {
                        message.success('重置成功');
                        adjustForm.setFieldsValue({ points: undefined, reason: undefined });
                        setAdjustFormDirty(false);
                        setFinallyScore(prev => ({ ...prev, finalScore: prev.averageScore }));
                        loadAdjustRecords(finallyScore.id);
                        setPaginat(draft => ({ ...draft }));
                    }
                });
            },
        });
    };

    /** 关闭调分弹窗（表单有变更时二次确认） */
    const handleFractionModalClose = () => {
        if (adjustFormDirty) {
            Modal.confirm({
                title: '提示',
                content: '调整分数没有保存，确认关闭并放弃变更?',
                okText: '放弃调整',
                okButtonProps: { danger: true },
                cancelText: '返回确认',
                onOk() {
                    setFractionModal(false);
                },
            });
        } else {
            setFractionModal(false);
        }
    };

    const closeCasesModal = () => {
        setCasesPaginat(draft => ({ page: 1, size: draft.size }));
        setSelectedRowKeys([]);
        topicForm.resetFields();
    };

    return (
        <>
            <PageHeader breadcrumb={[]}>
                <span className="back" onClick={() => navigate(workspaceSelectionReviewTopicsPath(params.pid, params.sid))}>
                    <i className="bi bi-chevron-left"></i>
                </span>
                <span className="current-title">评议实践管理</span>
                <span className="current-subtitle wrap-subtitle">
                    {local.state?.projectName}
                    <br />
                    {local.state?.stageName} - {local.state?.topicName}
                </span>
            </PageHeader>

            <div className="page-route-body cases-table-content">
                <Card
                    size="small"
                    className="cases-filter-panel"
                    style={{
                        marginBottom: token.marginLG,
                        border: `1px solid ${token.colorBorderSecondary}`,
                        background: token.colorFillAlter,
                    }}
                >
                    <Form form={form} name="cases-filter-form" {...filterFormItemLayout} initialValues={CASES_FILTER_INITIAL_VALUES} requiredMark={false} autoComplete="off" onFinish={handleSearch}>
                        <Row gutter={[16, 16]}>
                            <Col {...filterFormGridLayout}>
                                <Form.Item name="caseName" label="申报名称" style={filterFormItemStyle}>
                                    <Input allowClear placeholder="请输入申报名称" autoComplete="off" />
                                </Form.Item>
                            </Col>
                            <Col {...filterFormGridLayout}>
                                <Form.Item name="caseId" label="申报ID" style={filterFormItemStyle}>
                                    <Input allowClear placeholder="请输入申报ID" autoComplete="off" />
                                </Form.Item>
                            </Col>
                            <Col {...filterFormGridLayout}>
                                <Form.Item name="assignedState" label="专家分配" style={filterFormItemStyle}>
                                    <Select options={assignmentSelect} />
                                </Form.Item>
                            </Col>
                            <Col {...filterFormGridLayout}>
                                <Form.Item name="filesState" label="阶段材料" style={filterFormItemStyle}>
                                    <Select options={filesSelect} />
                                </Form.Item>
                            </Col>
                            <Col {...filterFormGridLayout}>
                                <Form.Item name="teamsState" label="阶段参与人" style={filterFormItemStyle}>
                                    <Select options={teamsSelect} />
                                </Form.Item>
                            </Col>
                            <Col {...casesFilterButtonColLayout}>
                                <Form.Item label={<span>&nbsp;</span>} colon={false} style={filterFormItemStyle}>
                                    <Space size="small">
                                        <Button type="primary" htmlType="button" onClick={handleSearch} icon={<i className="bi bi-search" aria-hidden="true" />}>
                                            检索
                                        </Button>
                                        <Button type="default" onClick={handleResetFilters}>
                                            重置
                                        </Button>
                                    </Space>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Card>
                <div className="cases-table-toolbar">
                    <Button type="primary" onClick={selectList}>
                        添加评议实践
                    </Button>
                    <div className="cases-table-toolbar-actions">
                        <div className="score-lock-control">
                            <Typography.Text className="score-lock-label">锁定专家评分</Typography.Text>
                            <Popconfirm title={scoreLocked ? '确认解锁专家评分？' : '确认锁定专家评分？'} description={scoreLocked ? '解锁后专家可继续修改评分，请谨慎操作！' : '锁定后专家将无法修改评分，请谨慎操作！'} okText="确认" cancelText="取消" onConfirm={handleLockConfirm}>
                                <Switch checked={scoreLocked} loading={lockLoading} checkedChildren={<i className="bi bi-lock" />} unCheckedChildren={<i className="bi bi-unlock" />} />
                            </Popconfirm>
                            <Typography.Text className={scoreLocked ? 'score-lock-status-locked' : 'score-lock-status-unlocked'}>{scoreLocked ? '已锁定' : '未锁定'}</Typography.Text>
                        </div>
                        <Button type="primary" onClick={checkList}>
                            核对结果
                        </Button>
                    </div>
                </div>
                <Table dataSource={dataSource.list} columns={columns} rowKey="index" pagination={false} loading={tableLoading} />
                <Pagination className="my-pagintation-class" showTotal={() => `共${dataSource.totalCount}条 ${Math.ceil(dataSource.totalCount / paginat.size)} 页`} total={dataSource.totalCount} showSizeChanger showQuickJumper onChange={onDataSourcePagination} current={paginat.page} size={paginat.size} />
            </div>

            <Modal centered width={1200} title="添加评议实践" footer={casesFooter} open={casesModal} onCancel={() => setCasesModal(false)} afterClose={closeCasesModal} className="cases-modal-wrapper">
                <Table dataSource={casesDataSource.list} columns={casesColumns} title={() => casesHeader} rowKey="id" pagination={false} loading={selectTableLoading} rowSelection={rowSelection} />
            </Modal>

            <Modal centered width={800} title="实践调分" open={fractionModal} footer={null} afterClose={resetAdjustModalData} onCancel={handleFractionModalClose} className="score-adjust-modal">
                <section className="score-adjust-case-info">
                    <div className="score-adjust-case-info-row">
                        <Typography.Text type="secondary" className="score-adjust-info-label">
                            申报编号
                        </Typography.Text>
                        <Typography.Text className="score-adjust-info-value">{currentCase?.caseId}</Typography.Text>
                    </div>
                    <div className="score-adjust-case-info-row">
                        <Typography.Text type="secondary" className="score-adjust-info-label">
                            申报名称
                        </Typography.Text>
                        <Typography.Text className="score-adjust-info-value">{currentCase?.caseName}</Typography.Text>
                    </div>
                    <div className="score-adjust-case-info-row">
                        <Typography.Text type="secondary" className="score-adjust-info-label">
                            申报机构
                        </Typography.Text>
                        <Typography.Text className="score-adjust-info-value">{currentCase?.hospitalName}</Typography.Text>
                    </div>
                </section>

                <Divider style={{ margin: '16px 0' }} />

                <Form layout="vertical" form={adjustForm} onFinish={handleAdjustSubmit} onValuesChange={() => setAdjustFormDirty(true)}>
                    <Row gutter={16} align="middle">
                        <Col flex="1">
                            <Statistic title="系统最终得分" value={finallyScore.averageScore === 0 || finallyScore.averageScore ? finallyScore.averageScore : '-'} formatter={formatScore} />
                        </Col>
                        <Col flex="1">
                            <Statistic className="score-adjust-display-score" title="最终显示得分" value={finallyScore.finalScore ?? '-'} formatter={formatScore} />
                        </Col>
                        <Col flex="none">
                            <Button danger variant="outlined" onClick={handleResetScore}>
                                重置分数
                            </Button>
                        </Col>
                    </Row>

                    <Divider style={{ margin: '16px 0' }} />

                    <Row gutter={24} align="top">
                        <Col span={12}>
                            <Form.Item
                                name="points"
                                label={deductPointsLabel}
                                validateTrigger={['onChange', 'onBlur']}
                                rules={[
                                    { required: true, message: '请输入扣除总分' },
                                    {
                                        validator: (_, value) => {
                                            if (value === null || value === undefined || value === '') {
                                                return Promise.resolve();
                                            }
                                            const decimalPart = String(value).split('.')[1];
                                            if (decimalPart && decimalPart.length > 4) {
                                                return Promise.reject(new Error('最多支持小数点后4位'));
                                            }
                                            const systemScore = Number(finallyScore.averageScore);
                                            if (!Number.isNaN(systemScore) && Number(value) > systemScore) {
                                                return Promise.reject(new Error('扣除分数不能大于系统最终得分'));
                                            }
                                            return Promise.resolve();
                                        },
                                    },
                                ]}
                            >
                                <InputNumber min={0} placeholder="请输入扣除总分" style={{ width: '100%' }} />
                            </Form.Item>

                            <Form.Item
                                name="reason"
                                label="减分理由"
                                validateTrigger={['onChange', 'onBlur']}
                                rules={[
                                    { required: true, message: '请填写减分理由' },
                                    { max: 200, message: '减分理由最多200字' },
                                ]}
                                extra={
                                    <div className="score-adjust-reason-presets">
                                        {REASON_PRESETS.map(preset => (
                                            <button key={preset} type="button" className="score-adjust-reason-preset" onClick={() => handleReasonPresetClick(preset)}>
                                                {preset}
                                                <i className="bi bi-arrow-up-left" style={{ fontSize: 12 }} />
                                            </button>
                                        ))}
                                    </div>
                                }
                            >
                                <Input.TextArea rows={4} placeholder="请填写减分理由" />
                            </Form.Item>

                            <Form.Item style={{ marginBottom: 0 }}>
                                <Button type="primary" htmlType="submit" block>
                                    确认减分
                                </Button>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Typography.Title level={5} className="score-adjust-section-title">
                                调分记录
                            </Typography.Title>
                            <div className="score-adjust-record-list-container">
                                <div ref={recordListRef} className="score-adjust-record-list-wrap" onScroll={updateRecordScrollFade}>
                                    <List size="small" className="score-adjust-record-list" loading={adjustRecordsLoading} dataSource={adjustRecords} locale={{ emptyText: '暂无调分记录' }} renderItem={renderAdjustRecordItem} />
                                </div>
                                {showRecordScrollFade ? <div className="score-adjust-record-list-fade" /> : null}
                            </div>
                        </Col>
                    </Row>
                </Form>
            </Modal>

            <Modal
                open={memberModalOpen}
                title="管理人员"
                footer={null}
                onCancel={() => setMemberModalOpen(false)}
                centered
                closable
                width={'1000px'}
                styles={{
                    body: {
                        width: '100%',
                        padding: '20px 30px',
                        minHeight: '600px',
                        zIndex: '100000000',
                    },
                }}
            >
                <div className="teamMemberHeader">
                    <h2>
                        <Tag color="#FF6A00">阶段</Tag>
                        {local.state?.stageName}
                    </h2>
                    <p>
                        项目：<span>{local.state?.projectName}</span>
                    </p>
                    <p>
                        实践：<span>{currentCase?.caseName}</span>
                    </p>
                    <div>
                        <p>
                            编号：<span>{currentCase?.caseId}</span>
                        </p>
                        {currentCase?.region && (
                            <p>
                                区域：<span>{currentCase?.region}</span>
                            </p>
                        )}
                        <p>
                            主题：<span>{local.state?.topicName}</span>
                        </p>
                    </div>
                </div>
                <Table columns={teamStageColumns} dataSource={memberDatas} pagination={false} loading={memberLoading} />
            </Modal>
        </>
    );
};

export default ScoreStageTopicList;
